import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';
import { config } from './config';

export const msalClient = new PublicClientApplication(config.msal.config);

export async function ecquireCredentials(): Promise<AuthenticationResult | null> {
  const activeAccount = msalClient.getActiveAccount();
  const accounts = msalClient.getAllAccounts();

  if (!activeAccount && !accounts.length) {
    return null;
  }

  const request = {
    scopes: config.msal.tokenScopes,
    account: activeAccount || accounts[0],
  };

  return msalClient.acquireTokenSilent(request);
}
